import { Dialog, DialogContent } from '@mui/material';
import { getPendingPayRoll } from 'lib/api/payments';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import CustomDialogTitle from 'lib/designSystem/DialogTitle';
import EnhancedTable from 'lib/designSystem/Table';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

const WithoutPayroll = (props: any) => {
  const { open, setOpen } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getPendingPayRoll(dispatch);
      setData(response || []);
    } catch (error) {
      console.error('Error calling getPendingPayRoll:', error);
      alert('Error al cargar las solicitudes sin nómina');
    }
    setLoading(false);
  };

  useEffect(() => {
    if (open) {
      void fetchData();
    }
  }, []);

  if (!open) return null;
  if (loading) return <CenteredCircularProgress type="dialog" />;
  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <CustomDialogTitle setOpen={setOpen}>
        Solicitudes sin nómina
      </CustomDialogTitle>
      <DialogContent>
        {loading ? (
          <CenteredCircularProgress type="dialog" />
        ) : (
          <EnhancedTable
            dataHeaders={[
              { key: 'id', label: 'Id', type: 'numeric-id' },
              { key: 'businessName', label: 'Cliente' },
              { key: 'sourceTranslation', label: 'Tipo' },
              { key: 'amount', label: 'Monto', type: 'money' },
              {
                key: 'operationDate',
                label: 'Fecha Operación',
                type: 'date',
              },
            ]}
            data={data}
            rowsPerPageDefault={10}
            exportToFile="xlsx"
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default WithoutPayroll;
